/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'jquery',
    'mustache',
    'pip-model',
    'jquery-fancybox',
    'plugin.tooltip',
    'pip-sharebelt-email',
    'thd-utils',
    'pip-events',
    '@thd-olt-global/thd-customer',
    'window'
],
function(
    $,
    Mustache,
    pip,
    fancybox,
    tooltip,
    pipSharebeltEmail,
    thdUtils,
    pipEvents,
    thdCustomer,
    window
){

    var tooltipTemplate = $('#sharebelt__tooltip').html();
    var cpoSuccessTooltipTemplate = $('#sharebelt__cpo__success__tooltip').html();
    var cpoFailureTooltipTemplate = $('#sharebelt__cpo__failure__tooltip').html();
    var cpoData;
    var THD_CUSTOMER_ROLE_ADMIN = 'ADMIN';

  function initEventListeners() {

    if (pip.features.customProductOfferingEnabled && pip.isB2BCustomer) {
      pipEvents.customProductOffering.cpoInfoReceived.on(
      function (event, cpoResponse) {
        if(thdCustomer.default.role === THD_CUSTOMER_ROLE_ADMIN) {
        cpoData = cpoResponse;
        if (cpoData.cpoId) {
          $('#cpo-sharebelt').removeClass('cpo__button--hidden');
          if (cpoData.inCpo) {
            $('#save-to-cpo').prop('disabled', true).addClass('cpo__button-disabled');
            $("#save-to-cpo").css("text-decoration", "none");
          }
        }
        }
      });

      $('#cpo-tooltip--state-success').tooltip({
        type: 'manual',
        position: 'bottom',
        content: function() {
          return Mustache.render(cpoSuccessTooltipTemplate, pip.features);
        },
        width: 'medium',
        closeButton: true,
        bestPosition: false,
        closeOnClick: true
      });

      $('#cpo-tooltip--state-failure').tooltip({
        type: 'manual',
        position: 'bottom',
        content: function() {
          return Mustache.render(cpoFailureTooltipTemplate, pip.features);
        },
        width: 'large',
        closeButton: true,
        bestPosition: false,
        closeOnClick: true
      });
  }


        $('#sharebelt__share').tooltip({
            type: 'click',
            position: 'bottom',
            content: function () {
                return Mustache.render(tooltipTemplate, pip.features);
            },
            width: 'small',
            closeButton: true,
            bestPosition: false,
            closeOnClick: true
        });


        $(document).on('click', '#save-to-cpo', function(e) {
          var baseUrl;
          if (pip.features.thdCustomerCookieEnabled) {
            baseUrl = "/b2b/cpo/v1/" + thdCustomer.default.svocID + "/" + thdCustomer.default.userID + "/cpo/items";
          }
          else {
            baseUrl = "/b2b/cpo/v1/" + cpoData.cookie.t + "/" + cpoData.cookie.u + "/cpo/items";
          }
          $.ajax(
            {
              url: baseUrl,
              headers: {
                'Content-Type': 'application/json'
              },
              contentType: "application/json",
              dataType:'json',
              method: "POST",
              xhrFields: {
                withCredentials: true
              },
              data: JSON.stringify({
                "cpoId": cpoData.cpoId,
                "itemList": [{
                  "itemId": pip.products.primary.data.itemId,
                  "isPreferred": false
                }]
              }),
              success: function(){
                $('#cpo-tooltip--state-success').tooltip('open');
                $('#save-to-cpo').prop('disabled',true).addClass('cpo__button-disabled');
                $("#save-to-cpo").css("text-decoration", "none");


              },
              error: function (err) {
                $('#cpo-tooltip--state-failure').tooltip('open');
                if (typeof window.newrelic === 'object' && window.newrelic.noticeError && window.newrelic.addPageAction) {
                  window.newrelic.addPageAction('CPOError', {
                    'errorSourceFile': 'pip-sharebelt',
                    'errorType': "AjaxError",
                    'errorStatus': err.status
                  });
                  window.newrelic.noticeError("Error calling b2b-cpo-service in pip-sharebelt");
                }
              }
            }
        );

        });




		$(document).on('click', '#sharebelt__facebook', function(e) {
			e.preventDefault();
			window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(location.href), 'facebook_share_dialog', 'width=626,height=436');
		});


		$(document).on('click', '#sharebelt__pinterest', function(e){
			e.preventDefault();
            $('#sharebelt__share').tooltip('close');
			pinImage();

			$.fancybox({
				'content' : $('#pinterest_overlay').html(),
				'width'         : 640,
				'height'        : 510,
				'margin': 0,
				'padding': 0,
				'autoDimensions'    : false,
				'autoSize': false,
				'scrolling': 'no',
				'centerOnScroll': true,
				'enableEscapeButton': true,
				'modal': false,
				'overlayColor': '#666',
				'overlayOpacity': 0.7,
				"showCloseButton": true
			});
		});

		$(document).on('click', '.pinthis-imageOuter_32x32', function(event) {
		    var cm_mmc;
		    if(pip.corporateInformation && pip.corporateInformation.fiscalYear) {
		        cm_mmc = 'socialmedia|O|FY' + pip.corporateInformation.fiscalYear.substr(2,4) + '|NA|PIN|'+ pip.products.primary.data.info.productDepartment +'|'+ pip.products.primary.data.info.classNumber +'|PIPsave|'+ pip.products.primary.data.itemId +'|';
		    }
			var pinterestUrl = 'pinterest.com/pin/create/button/?url=' + thdUtils.setURLParam(document.location.href, 'cm_mmc', cm_mmc) +
				'&media=' + $(this).find('img').attr('src') + '&description=' + document.title;
			encodeURIComponent(pinterestUrl);
			window.open('//' + pinterestUrl,'pinterest_share_dialog','width=626,height=436');
		});

		$(document).on({
		    mouseenter: function () {
		    	$(this).find('.pinterest_icon').show();
				$(this).find(".pinterestEqualSizeImage").addClass('pinterestEqualSizeImageHover');
		    },

		    mouseleave: function () {
		    	$(this).find('.pinterest_icon').hide();
				$(this).find(".pinterestEqualSizeImage").removeClass('pinterestEqualSizeImageHover');
		    }
		}, '.pinthis-imageOuter_32x32');


    $(document).on('click', '#cpo-sharebelt', function () {
      if (pip.features.customProductOfferingEnabled && pip.isB2BCustomer) {
        addToCpoAnalyticsEvent()
      }
    });


	}

	function addToCpoAnalyticsEvent() {
    const digitalDataObject = {
      category: {
        primaryCategory: "button submission"
      },
      eventInfo: {
        eventName: "my account settings"
      },
      myAccount: {
        settings: "custom catalog: save from pip"
      }
    };
    pushAnalyticsEvent(digitalDataObject);
  }

  function pushAnalyticsEvent(analyticsEventObject) {

    if (pip.debugMode) {
      console.log('DDO Add to Cart Event:', analyticsEventObject);
    }

    if (window.digitalData && window.digitalData.event) {
      window.digitalData.event.push(analyticsEventObject);
    }
  }

	function pinImage(media){

		$('#pinterest_overlay').remove();
		$("body").append("<div id='pinterest_overlay'></div>");

		var header = '<div id="pinterest_header"><span class="dwarf-pinterestIcon small-icon"></span> <h3 class="pinterest_headermsg">Pin It to Pinterest</h3>' +
				'<a class="pinterest_headerclose" href="#" title="Close"></a></div>';
		$('#pinterest_overlay').hide().append(header);
		$('#pinterest_overlay').append("<div id='pinterest_body'></div>");
		$('#pinterest_overlay').append("<div id='pinterest_footer'></div>");

		var pinImg = "";
		$('img').each(function(){
			var imageWidth = $(this).width();
			var imageHeight = $(this).height();
			var pinterest_imageSizeInfo = '<span class="pinterest_imageSize">';
			if( imageWidth >= 145 && imageHeight >= 100 ) {
				var src = $(this).attr('src');
				//Check if the image source path is relative, if so form the absolute image path
				src = ( src.indexOf(".com") !== -1 ) ? src : ( '//' + document.location.host + src );

				if(imageHeight === 300){
					pinterest_imageSizeInfo = pinterest_imageSizeInfo + 'Preferred Image </span>';
				}else{
					pinterest_imageSizeInfo = pinterest_imageSizeInfo + imageHeight + ' x ' + imageWidth + ' </span>';
				}
				pinImg = pinImg + '<span class="pinthis-imageOuter_32x32" >';
				pinImg = pinImg + '<span class="pinthis-imageInner_32x32" >' +
								'<img alt="' + (($(this).attr('alt') !== undefined ) ? $(this).attr('alt') : '') + '" class="pinterestEqualSizeImage" src="' + src + '" height="" width=""/> </a> </span><div class="pinterest_icon dwarf-pinterest"></div> ' + pinterest_imageSizeInfo + '</span>';
			}
		});
		$('#pinterest_body').append(pinImg);

	}

	return {
		init: function(){
			initEventListeners();
            pipSharebeltEmail.init();
		}
	};

});

}.call(window));